import { render, staticRenderFns } from "./mainManege.vue?vue&type=template&id=0cb5c31c&"
import script from "./mainManege.vue?vue&type=script&lang=js&"
export * from "./mainManege.vue?vue&type=script&lang=js&"
import style0 from "./mainManege.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports